import { Flex } from 'antd';
import styled from 'styled-components';
import { ImageContainer as CommonImageContainer } from '../../styles/commonStyles';

export const Container = styled(Flex).attrs({
  vertical: true,
  gap: 8,
  flex: 1,
})`
  width: 100%;
  overflow: hidden;
  &.checkable {
    padding: 16px;
    cursor: pointer;
  }
  &.checked {
    background: #f4f9ec;
  }
  &:hover {
    cursor: pointer;
  }
`;

export const ImageContainer = styled(CommonImageContainer)`
  width: 80px;
  height: 60px;
`;

export const IssueName = styled.p`
  font-weight: 500;
  margin: 0;
  line-height: 20px;
  font-size: 12px;
`;

export const Description = styled.p`
  margin: 0;
  line-height: 20px;
  font-size: 12px;
  color: #85878b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`;

export const ActionButtonWrapper = styled.div`
  padding: 8px;
  color: #999b9e;
  &:hover {
    color: ${(props) => props.theme.antd?.colorPrimary};
  }
`;
